import { useEffect, useMemo, useState } from "react";

import {
  createDeviceProfile,
  DeviceProfile,
} from "./DeviceProfile";

import {
  resolveLayoutMode,
  LayoutMode,
} from "./LayoutMode";

import {
  createUILayout,
  UILayoutProfile,
} from "./UILayoutProfile";

export interface UILayoutState {
  device: DeviceProfile;
  mode: LayoutMode;
  layout: UILayoutProfile;
}

export function useUILayout(): UILayoutState {

  const [device, setDevice] = useState<DeviceProfile>(
    () => createDeviceProfile()
  );

  useEffect(() => {

    const update = () => {
      setDevice(createDeviceProfile());
    };

    window.addEventListener("resize", update);

    window.visualViewport?.addEventListener(
      "resize",
      update
    );

    return () => {

      window.removeEventListener(
        "resize",
        update
      );

      window.visualViewport?.removeEventListener(
        "resize",
        update
      );

    };

  }, []);

  const mode = useMemo(
    () => resolveLayoutMode(device),
    [device]
  );

  const layout = useMemo(
    () => createUILayout(device, mode),
    [device, mode]
  );

  return {

    device,

    mode,

    layout,

  };

}
